export default "__VITE_PUBLIC_ASSET__e74cae84__"